import React from 'react';
import '../style/Teaching.scss';
// react bootstrap
import { Container } from 'react-bootstrap';
import Header from '../components/public/Header';

function Teaching2() {
  return (
    <>
      <Header />
      <Container>
        <div className='content'>
          <h3 className='text-left text-secondary'>如何運行脈的形成</h3>
          <p className='chineseParagraph'>
            按照續部經典記載,懷孕的第35天開始胎兒的中脈開始成形,
            中脈的大小約為胎兒指甲的十二分之一大。胎兒從第35天起每一天會形成200個脈，9個月會形成54000條脈。且受精卵結合時早已具備由前世帶來的阿賴耶識，並具地水火風空五大種。
            在人體的脈當中，中脈是最關鍵的，其次是左脈與右脈，以及從三脈當中支分出來的七萬二千根大小各異並且與修行相關的脈。
            胎兒第一個月發展心輪的8個脈瓣,第二個月是臍輪的64個脈瓣,第三個月是喉輪16個脈瓣，頂輪32個脈瓣,密輪32個脈瓣...等。
          </p>
        </div>
      </Container>
    </>
  );
}

export default Teaching2;
